// src/rms/ads/AdRail.js
// ============================================================================
// Full-height right rail
// ============================================================================
// Renders the stack chosen by useAdSurfaces down the right edge of every screen
// where ads are permitted. Mounted once in RmsLayout rather than per page, so
// new screens inherit it automatically — and so suppressing it on transactional
// routes is a single decision rather than one per page.
//
// Renders nothing at all on the ad-free tier or when there is no demand.
// ============================================================================

import React from "react";
import AdUnit from "./AdUnit";
import { useRms } from "../context/RmsContext";

function AdRail({ stack = [] }) {
  const { t } = useRms();
  if (!stack.length) return null;

  return (
    <aside className="rms-adrail" aria-label={t("adRail.advertisements", "Advertisements")}>
      {stack.map(({ slot, slotKey, campaign }) => (
        <AdUnit key={slotKey} slot={slot} slotKey={slotKey} campaign={campaign} variant="rail" />
      ))}
    </aside>
  );
}

export default AdRail;
